import React, { useEffect, useState } from "react";
import { HStack, Button } from "@chakra-ui/react";
import { Raider } from "../../../types/raider";
import {
	tokenAllowanceCheck,
	tokenApproval,
} from "../../../util/web3/interactBank";
import {
	canRaiderRecruit,
	recruitRaider,
	getRecruitmentCost,
	getNextRecruitTime,
	getNextGenToRecruit,
} from "../../../util/web3/interactRecruiting";
import { timeConverter } from "../../../util/helpers";

interface RecruitButtonProps {
	raider: Raider;
	toast: any;
}

export default function RecruitButton(props: RecruitButtonProps) {
	const { raider, toast } = props;
	const [cost, setCost] = useState<number>();
	const [canRecruit, setCanRecruit] = useState<boolean>();
	const [nextRecruit, setNextRecruit] = useState<number>(0);

	const handleRecruiting = async (raiderId: number) => {
		if (process.env.NEXT_PUBLIC_RECRUITING) {
			const allowance = await tokenAllowanceCheck(
				"AURUM",
				process.env.NEXT_PUBLIC_RECRUITING
			);

			if (!allowance || parseInt(allowance) < 3000) {
				await tokenApproval("AURUM", process.env.NEXT_PUBLIC_RECRUITING, toast);
			} else if (parseInt(allowance) >= 3000) {
				await recruitRaider(raiderId, toast);
			}
		}
	};

	useEffect(() => {
		const getStatus = async () => {
			// const gen = raider.attributes[3].value;
			const nextGenToRecruit = await getNextGenToRecruit(parseInt(raider.id));
			if (nextGenToRecruit == "7") {
				setCanRecruit(false);
			} else {
				const tempCanRecruit = await canRaiderRecruit(parseInt(raider.id));
				setCanRecruit(tempCanRecruit);
				if (tempCanRecruit) {
					setCost(parseInt(await getRecruitmentCost(parseInt(raider.id))));
				}
				else {
					setNextRecruit(await getNextRecruitTime(parseInt(raider.id)));
				}
			}
		};

		getStatus();
	},[]);

	return (
		<HStack width="100%">
			<Button
				// rightIcon={<BiBeer />}
				colorScheme="gray"
				width="full"
				onClick={() => handleRecruiting(parseInt(raider.id))}
				disabled={!canRecruit}
				// onClick={() =>
				// 	toast({
				// 		title: "Quests will resume soon!",
				// 		description:
				// 			"Starting new quests is currently paused while we improve the user experience, please call home any Raiders and we'll resume questing soon. See our Discord for more information.",
				// 		status: "error",
				// 		duration: 9000,
				// 		position: "top",
				// 		isClosable: true,
				// 	})
				// }
			>
				{canRecruit
					? `Recruit for ${cost} Aurum`
					: ``}
				{!canRecruit && nextRecruit > 0 ? `Recruit in ${timeConverter(nextRecruit)}` : ``}
				{!canRecruit && nextRecruit == 0 ? `Recruit Limit Reached` : ``}
			</Button>
		</HStack>
	);
}
